export const TermsAndConditions = require("./DTY Website Terms and Conditions of Use 2016.pdf");
